import React from 'react'

const About = () => {
    return (
        <main className="about-section section">
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod deserunt dolorem, voluptas fuga unde at adipisci eos temporibus debitis aperiam suscipit illo dolores doloremque distinctio architecto assumenda consequatur aliquid qui aut quia sit perspiciatis reiciendis enim. Ipsa nesciunt assumenda porro.
                 
            </p>
        </main>
    )
}

export default About